import * as stream from "stream";

export default {
    bind(el, binding) {
        let str =`AGE : ${binding.value.age} <br>`

        if(binding.value.lastCrewActivities.length) {
            str+= `<p style="text-align: left">LAST JPN VESSELS:</p>`
            str+= `<ol style="list-style: none">`
            binding.value.lastCrewActivities.forEach(item=>{
                str+= `<li>${item.vessel} <br>${item.start_date}</li>`
            })
            str+= `</ol>`
        }

        if (/<\/?[a-z][\s\S]*>/i.test(binding.value)) {
            el.setAttribute("data-html", "true"); // Vue 2 uses Bootstrap 4 => data-html
        }
        $(el).attr("title", str || "")
        $(el).tooltip();
    },
    update(el, binding) {
        let str =`AGE : ${binding.value.age} <br>`

        if(binding.value.lastCrewActivities.length) {
            str+= `<p style="text-align: left">LAST JPN VESSELS:</p>`
            str+= `<ol style="list-style: none">`
            binding.value.lastCrewActivities.forEach(item=>{
                str+= `<li>${item.vessel} <br> ${item.start_date}</li>`
            })
            str+= `</ol>`
        }

        if (/<\/?[a-z][\s\S]*>/i.test(binding.value)) {
            el.setAttribute("data-html", "true"); // Vue 2 uses Bootstrap 4 => data-html
        }

        $(el)
            .attr("title", str || "")
            .tooltip("dispose") // remove old tooltip
            .tooltip(); // re-init
    },
    unbind(el) {
        // Cleanup on element removal
        $(el).tooltip("dispose");
    }
};